export default __webpack_public_path__ + "static/media/cata.6ed146b3.png";